import { configureStore } from '@reduxjs/toolkit';
import appConfReducer from "./AppConf/AppConfReducer"
import appDataReducer from './AppData/AppDataReducer';
import cartsReducer from './Cart/CartReducer';
import userDataReducer from './UserData/UserDataReducer';
import loaderCommonsReducer from "./LoaderCommons/LoaderCommonsReducer"
import loadingReducer from './Loading/LoadingReducer';
import headerAlertReducer from './HeaderAlert/HeaderAlertReducer';

const store = configureStore({ 
    reducer: {
        appConf: appConfReducer,
        appData: appDataReducer,
        dics: loaderCommonsReducer,
        cart: cartsReducer,
        userData: userDataReducer,
        loading: loadingReducer,
        alert: headerAlertReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
})

export default store

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch